<template>
    <!-- 分享标签 -->
    <div id="signCorner"
        class="share-btn-area"
        :style="newBlindBoxStyle ? newBlindBoxStyle : tagPositionStyle"
        @click="openGuide()">
        <div class="share-title">
            分享
        </div>
        <div class="share-desc">
            剩余{{ remainingSharingTimes }}次
        </div>
    </div>
</template>
<script>
import { BigWheelConstants as BWC } from '../common/global-variable';

export default {
  props: {
    // 剩余分享次数
    remainingSharingTimes: {
      type: Number,
      default: 0
    },
    
    activityConfig: {
      type: Object,
      default: function() {
        return {}
      }
    },
    // 活动样式，包括：1-大转盘，2-盲盒，3-轮盘锦鲤（老虎机），4-新盲盒
    bigWheelActivityType: {
      type: String,
      default: ''
    }
  },
  data(){
    return {
      
    }
  },
  computed: {
    // 新盲盒场景，样式写死，暂不支持配置
    newBlindBoxStyle() {
      if (this.bigWheelActivityType === BWC.BigWheelActivityType.newBlindBox) {
        return {
          top: `75vh`,
          right: 0,
          'border-radius': '18px 0 0 18px',
          padding: '3px 5px 3px 11px',
          color: '#b27d13',
          'background-image': `linear-gradient(90deg, #faf2df 0%, #f1e1c2 100%)`
        }
      } else {
        return null;
      }
    },
    // 分享标签位置，共四种值：'left-top' | 'right-top' | 'left-down' | 'right-down'
    // 1:右下，2:右上，3:左上，4:左下
    position(){
      let res = 'right-down';
      if (this.activityConfig && this.activityConfig.shareIconLocation) {
        switch(this.activityConfig.shareIconLocation) {
          case '1':
            res = 'right-down';
            break;
          case '2':
            res = 'right-top';
            break;
          case '3':
            res = 'left-top';
            break;
          case '4':
            res = 'left-down';
            break;
          default:
            res = 'right-down';
        }
      }
      return res;
    },
    // 文本颜色
    textColor() {
      if(this.activityConfig && this.activityConfig.shareIconTextColor) {
        return this.activityConfig.shareIconTextColor
      } else if (this.bigWheelActivityType === BWC.BigWheelActivityType.bigTurnable) {
        return '#256FFF'
      } else if (this.bigWheelActivityType === BWC.BigWheelActivityType.blindBox) {
        return '#B27D13'
      } else if (this.bigWheelActivityType === BWC.BigWheelActivityType.tigerMachine) {
        return '#AE2C40'
      } else {
        return '#000'
      }
    },
    // 背景色
    bgColor() {
      if(this.activityConfig && this.activityConfig.shareIconBackgroudColor) {
        return this.activityConfig.shareIconBackgroudColor
      } else {
        return '#fff'
      }
    },
    tagPositionStyle(){
      let commonStyle = {
        color: this.textColor,
        'background-color': this.bgColor
      }
      if (this.position === 'right-down') {
        commonStyle = Object.assign(commonStyle, {
          top: `75vh`,
          right: 0,
          'border-radius': '18px 0 0 18px',
          padding: '3px 5px 3px 11px'
        }) 
      } else if (this.position === 'right-top') {
        commonStyle = Object.assign(commonStyle, {
          top: `86px`,
          right: 0,
          'border-radius': '18px 0 0 18px',
          padding: '3px 5px 3px 11px'
        }) 
      } else if (this.position === 'left-top') {
        commonStyle = Object.assign(commonStyle, {
          top: `86px`,
          left: 0,
          'border-radius': '0 18px 18px 0',
          padding: '3px 12px 3px 4px'
        }) 
      } else if (this.position === 'left-down') {
        commonStyle = Object.assign(commonStyle, {
          top: `75vh`,
          left: 0,
          'border-radius': '0 18px 18px 0',
          padding: '3px 12px 3px 4px'
        }) 
      } else {
        // 未匹配成功，则默认右下
        commonStyle = Object.assign(commonStyle, {
          top: `calc(100vh - 198px)`,
          right: 0,
          'border-radius': '18px 0 0 18px',
          padding: '3px 5px 3px 11px'
        })
      }
      return commonStyle;
    }
  },
  methods: {
    openGuide() {
      this.$emit('openGuide');
    }
  }
};
</script>
<style scoped lang='scss'>
.share-btn-area {
  background: #fff;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  position: fixed;
  z-index: 10;
  max-width: 130px;
  line-height: 15px;
  box-sizing: border-box;
  font-size: 2.6666vw;
  font-family: HONORSansBrand-Regular;
  .share-title {
    text-align: center;
    font-family: HONORSansBrand-DemiBold;
    font-weight: 600;
  }
  .share-desc {
    font-family: HYQiHei-EES;
    text-align: center;
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/lucky-draw/components/share-tag.vue